import { fetchDataset } from "@hashintel/utils/lib/datasets/fetchDataset";
import { runPythonNamespaced, runnerPython, updatePythonDatasetCache, } from "./buildpython";
let datasetNamespace = null;
export async function fetchDatasetContent(datasets, cache) {
    const data = {};
    const kvps = await Promise.all(datasets.map((dataset) => {
        return Promise.resolve()
            .then(() => {
            if (cache.has(dataset.s3Key)) {
                return Promise.resolve(cache.get(dataset.s3Key)?.data);
            }
            if (dataset.format) {
                return fetchDataset(dataset.url, dataset.format, dataset.inPlaceData);
            }
            throw new Error(`Unknown dataset format ${dataset.format}`);
        })
            .then((value) => ({
            name: dataset.shortname,
            value,
            s3Key: dataset.s3Key,
        }))
            .catch((err) => {
            console.error(err);
            console.error("Unable to load dataset", dataset.shortname, dataset.id);
            return null;
        });
    })).then((datakeys) => datakeys.filter((kvp) => kvp !== null));
    for (const kvp of kvps) {
        data[kvp.name] = kvp.value;
        if (!cache.hasOwnProperty(kvp.s3Key)) {
            cache.set(kvp.s3Key, { data: kvp.value, name: kvp.name });
        }
    }
    return data;
}
export const refreshPyodideDatasetCache = async (cache) => {
    if (datasetNamespace === null) {
        datasetNamespace = self.pyodide.toPy({});
    }
    if (!datasetNamespace.has("cached_dataset_names")) {
        datasetNamespace.set("cached_dataset_names", self.pyodide.toPy([]));
        datasetNamespace.set("cached_datasets", self.pyodide.toPy({}));
    }
    const pyodideCachedNames = datasetNamespace
        .get("cached_dataset_names")
        .toJs();
    for (const [k, v] of cache.entries()) {
        if (!pyodideCachedNames.includes(k) && runnerPython !== null) {
            const { data, name } = v;
            datasetNamespace.set("pythonDatasetCache", JSON.stringify(data));
            await runPythonNamespaced(`
import json
cached_dataset_names.append("${k}")
cached_datasets["${name}"] = json.loads(pythonDatasetCache)
pythonDatasetCache = ""
 `, datasetNamespace);
        }
    }
    updatePythonDatasetCache(datasetNamespace.get("cached_datasets"));
};
//# sourceMappingURL=dataset.js.map